module.exports = __webpack_public_path__ + "static/media/Sort_unselected.7b0db04e.svg";